import {GET_FOLLOW, GET_FOLLOWERS_LIST} from '../data/follow_data'
import {GET_FOLLOW_USER} from '../data/comment_data'
import {REMOVE_FOLLOW,ADD_TO_FOLLOW,SET_FOLLOW} from '../store/actions'
import UserInfo from '../model/userinfo'

const initialState = {
  follow:[],
  followersList:[],
  userFollow:{}
}

export default (state=initialState,actions) =>{
  switch (actions.type) {
    case GET_FOLLOW:
    return{
      ...state,follow:actions.data
    }
    case GET_FOLLOWERS_LIST:
    return{
      ...state,followersList:actions.data
    }
    case GET_FOLLOW_USER:
    return{
      ...state,userFollow:actions.data[0]
    }
   case REMOVE_FOLLOW:
   return{
     ...state,
      follow:state.follow.filter(prod => prod.userid !== actions.userid)

   }
   case SET_FOLLOW: {
     const id = String(actions.userid || '')
     if (actions.unsubscribe) {
       return { ...state, follow: state.follow.filter(user => String(user.userid) !== id && String(user.id) !== id) }
     }
     const index = state.follow.findIndex(user => String(user.userid) === id || String(user.id) === id)
     if (index < 0) {
       const next = new UserInfo(actions.userid, actions.userid, actions.email, actions.postition, actions.job, actions.hobby)
       next.notifyAll = !!actions.notify
       return { ...state, follow: state.follow.concat(next) }
     }
     const up = [...state.follow]
     up[index] = { ...up[index], notifyAll: !!actions.notify }
     return { ...state, follow: up }
   }
   case ADD_TO_FOLLOW:
   const idIndex = state.follow.findIndex(user => user.userid === actions.userid);
   if(idIndex < 0){
    const fl = new UserInfo(actions.userid,actions.userid,actions.email,actions.postition,actions.job,actions.hobby)
   return{
     ...state,
      follow:state.follow.concat(fl)

   }}else{
     const up = [...state.follow];
     up.splice(idIndex,1)
     return{
       ...state,
       follow:up
     }
   }
  }
  return state;
}
